import pmManagementService from '@/services/pmManagementService';

export default {
  namespaced: true,

  state: {
    portfolio: null,
    loading: false,
    error: null,
  },

  getters: {
    loading: (state) => state.loading,
    error: (state) => state.error,
    portfolio: (state) => state.portfolio,
    decisionFocus: (state) => state.portfolio?.decisionFocus ?? [],
    portfolioRisk: (state) => state.portfolio?.portfolioRisk ?? [],
    comparison: (state) => state.portfolio?.comparison ?? null,
    insights: (state) => state.portfolio?.insights ?? null,
    blockages: (state) => state.portfolio?.blockages ?? { recurringCauses: [], responsibilityAreas: [] },
  },

  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_PORTFOLIO(state, portfolio) {
      state.portfolio = portfolio;
    },
    RESET(state) {
      state.portfolio = null;
      state.loading = false;
      state.error = null;
    },
  },

  actions: {
    async fetchPortfolio({ commit }) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      try {
        const portfolio = await pmManagementService.getPortfolio();
        commit('SET_PORTFOLIO', portfolio);
        return portfolio;
      } catch (error) {
        commit('SET_ERROR', error?.message || 'Failed to load management portfolio');
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
  },
};
